import { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import { setSelectedMenu } from "../../Redux/Actions/actions";
import {
  BaseUrl,
  excelDownloadUrl,
} from "../../Container/BaseUrl/BaseUrl";
import axios from "axios";
import moment from "moment";
import { toast } from "react-toastify";
import { toaststyle } from "../../Utils/toaststyle";
import { Hourglass } from "react-loader-spinner";
import { DownloadSimple, FunnelSimple } from "@phosphor-icons/react";
import { IoIosArrowBack } from "react-icons/io";
import {
  Button,
  Stack,
  Pagination,
  Typography,
  Box,
  Drawer,
  ButtonGroup,
} from "@mui/material";
import {
  StyledPaper,
  StyledTableContainer,
  StyledTable,
  StyledTableHead,
  StyledTableBody,
  StyledTableRow,
  StyledTableCell,
  StyledTableCell2,
} from "../../CustomComponent/TableCompoent";
import { Badge } from "react-bootstrap";
import Nodata from "../../Assets/images/svg/Data-unavailable.svg";

const mapStateToProps = (state) => {
  return {
    selectedMenu: state.contactListData.selectedMenu,
    agentlistdata: state.data.agentlistdata,
  };
};
const WhatsappOutboundReport = (props) => {
  const selectAgentRef = useRef(null);

  var someDate = new Date();
  var date = someDate.setDate(someDate.getDate());
  var defaultValue = new Date(date).toISOString().split("T")[0];
  const [showfilter, setShowFilter] = useState(false);
  const [calldetailsreportlist, setCalldetailsreportlist] = useState([]);
  const [fromdate, setFromdate] = useState(defaultValue);
  const [todate, setTodate] = useState(defaultValue);
  const [page, setPage] = useState(1);
  const [pagination, setPagination] = useState(0);
  const [skillspinner, setSkillspinner] = useState(false);
  const [fromDateError, setFromDateError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = () => {
    if (moment(fromdate).isAfter(todate)) {
      setFromDateError(true);
      setShowFilter(true);
    } else {
      outboundwhatsappReportData();
      setFromDateError(false);
      handelCloseFilter();
    }
  };

  const handelShowFilter = () => {
    setShowFilter(true);
  };
  const handelCloseFilter = () => {
    setShowFilter(false);
  };

  useEffect(() => {
    outboundwhatsappReportData();
  }, [page]);

  const outboundwhatsappReportData = async () => {
    setSkillspinner(true);
    await axios
      .post(
        BaseUrl + "/users/outboundwhatsappReport",
        {
          from_date: fromdate,
          to_date: todate,
          offset: page == 1 ? 0 : (page - 1) * 10,
          limit: 10,
        },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token"),
            "Content-Type": "application/json",
            tenantId: localStorage.getItem("TenantId"),
          },
        }
      )
      .then((res) => {
        setSkillspinner(true);
        if (res.data) {
          setCalldetailsreportlist(res.data.data);
          setPagination(res.data.count);
          setSkillspinner(false);
        } else {
          setSkillspinner(false);
          setCalldetailsreportlist([]);
        }
      })

      .catch((error) => {
        setSkillspinner(false);
        setCalldetailsreportlist([]);
        console.log(error);
      });
  };

  const skillsetReportDataDownload = async () => {
    setIsLoading(true);
    await axios
      .post(
        BaseUrl + "/users/outboundwhatsappReportexcel",
        {
          from_date: fromdate,
          to_date: todate,
          offset: page == 1 ? 0 : (page - 1) * 10,
          limit: 10,
        },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token"),
            "Content-Type": "application/json",
            tenantId: localStorage.getItem("TenantId"),
          },
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token"),
            "Content-Type": "application/json",
            tenantId: localStorage.getItem("TenantId"),
          },
        }
      )
      .then((response) => {
        setIsLoading(true);
        if (response.data.status) {
          setIsLoading(false);
          let downloadEmailasPdf =
            excelDownloadUrl + response.data.message;
          window.open(downloadEmailasPdf);

          toast.success(
            "Whatsapp Outbound Report Downloaded Successfully",
            toaststyle
          );
        } else {
          setIsLoading(false);
          toast.warning(response.data.Message, toaststyle);
        }
      })

      .catch((error) => {
        console.log(error);
      });
  };

  const handleChange = (event, value) => {
    setPage(value);
  };

  const resetButton = () => {
    selectAgentRef.current.clearValue();
    setTodate("");
    setFromdate("");
    handelCloseFilter();
  };

  return (
    // Whatsapp Outbound Report  start here 
    <StyledPaper>
      <div className="card Report-card w-100 border-0">
        {/* card-header  */}
        <div
          className="card-header border-0 d-flex align-items-center justify-content-between px-2"
          sx={{ fontWeight: 600, color: "#1473e6" }}
        >
          <div
            className="fw-bold fs-16"
            style={{
              textShadow: "1px 0px 0px #c2c2c27d",
              color: "#0b3363",
            }}
          >
            Whatsapp Outbound Report
          </div>
          <div>
            <ButtonGroup
              variant="contained"
              aria-label="button group"
              disableElevation
              size="small"
              sx={{
                textTransform: "capitalize",
              }}
            >
              {/* Back btn  */}
              <Button
                sx={{
                  textTransform: "capitalize",
                }}
                onClick={() => {
                  props.setSelectedMenu("ReportMenu");
                }}
              >
                <IoIosArrowBack className="me-2" />
                Back
              </Button>
              {/* Download btn  */}
              <Button
                sx={{
                  textTransform: "capitalize",
                }}
                onClick={skillsetReportDataDownload}
                disabled={isLoading}
              >
                <DownloadSimple className="me-2" />
                {isLoading ? "Downloading..." : "Download Report"}
              </Button>
              {/* Filter btn  */}
              <Button
                sx={{
                  textTransform: "capitalize",
                }}
                onClick={handelShowFilter}
              >
                <FunnelSimple className="me-2" />
                Filter
              </Button>
            </ButtonGroup>
          </div>
        </div>
        {/* card-body */}
        <div
          className="card-body p-1 vh-71 box-inset"
          sx={{
            justifyContent: "center",
            display: "flex",
            height: "calc(100% - 40px)",
            display: "flex",
            flexDirection: "column",
            gap: "10",
          }}
        >
          <Box>
            <StyledTableContainer sx={{ height: "26rem !important" }}>
              <StyledTable stickyHeader aria-label="sticky table" size="small">
                <StyledTableHead>
                  <StyledTableRow>
                    {[
                      "Agent Name",
                      "Phone Number ",
                      "Type",
                      "Created at",
                      "Customer Responded",
                    ].map((headers) => (
                      <StyledTableCell style={{ minWidth: "150px" }}>
                        {headers}
                      </StyledTableCell>
                    ))}
                  </StyledTableRow>
                </StyledTableHead>
                <StyledTableBody>
                  {skillspinner ? (
                    <Stack sx={{ position: "absolute", top: "50%", left: "50%" }}>
                      <Hourglass
                        visible={true}
                        height="30"
                        width="30"
                        ariaLabel="hourglass-loading"
                        wrapperStyle={{}}
                        wrapperClass=""
                        colors={["#2268a0", "#72a1ed"]}
                      />
                    </Stack>
                  ) : calldetailsreportlist ? (
                    calldetailsreportlist.map((item, index) =>
                      <StyledTableRow
                        hover
                        role="checkbox"

                      >

                        <>
                          <StyledTableCell2>
                            {item.agent_name}
                          </StyledTableCell2>

                          <StyledTableCell2>
                            {item.phonenumber}
                          </StyledTableCell2>
                        </>


                        <StyledTableCell2>
                          {item.type_customer}
                        </StyledTableCell2>

                        <StyledTableCell2>
                          {moment(item.created_at).format('DD/MM/YYYY,hh:mm:ss A')}
                        </StyledTableCell2>

                        <>
                          <StyledTableCell2>
                            {item.chatinitiated == true ? <Badge bg="success" >True</Badge> : <Badge bg="danger">False</Badge>}
                          </StyledTableCell2>
                        </>

                      </StyledTableRow>

                    )
                  ) : (
                    <>

                      {/* // Data unavailable start */}
                      <Stack
                        sx={{
                          position: "absolute",
                          width: "100%",
                          height: "calc(100vh - 14rem)",
                        }}
                        justifyContent="center"
                        alignContent="center"
                      >
                        <Stack
                          className="text-muted"
                          direction="column"
                          justifyContent="center"
                          alignContent="center"
                        >
                          <span className="mx-auto">
                            <img
                              src={Nodata}
                              alt="pic"
                              style={{ width: "11rem", userSelect: "none" }}
                            />
                          </span>
                          <span className="mx-auto">
                            <h6
                              className="text-muted mt-3"
                              style={{ fontSize: "13px" }}
                            >
                              Data unavailable
                            </h6>
                          </span>
                        </Stack>
                      </Stack>
                      {/* // Data unavailable end */}
                    </>
                  )}
                </StyledTableBody>
              </StyledTable>
            </StyledTableContainer>
          </Box>
        </div>
        {/* card-footer */}
        <div className="card-footer border-0">
          <Box>
            <Stack
              sx={{ width: "100%", height: "100%" }}
              direction={"row"}
              alignItems={"center"}
              justifyContent={"space-between"}
            >
              {/* Pagination content  */}
              <Typography variant="caption" sx={{ fontSize: "12px" }}>
                Showing{" "}
                {Math.min(
                  (page - 1) * 10 + 1,
                  isNaN(pagination) ? 0 : pagination
                )}{" "}
                to {Math.min(page * 10, isNaN(pagination) ? 0 : pagination)} of{" "}
                {isNaN(pagination) ? 0 : pagination} entries
              </Typography>

              {/* Pagination  */}
              <Pagination
                count={Math.ceil(pagination / 10)}
                page={page}
                shape="rounded"
                color="primary"
                size="small"
                style={{ float: "right" }}
                onChange={handleChange}
              />
            </Stack>
          </Box>
        </div>
      </div>
      {/* Filters Drawer Start  */}
      <Drawer
        anchor="right"
        open={showfilter}
        onClose={() => {
          setShowFilter(false);
        }}
      >
        <Box style={{ width: "20rem" }}>
          {/* Drawer head start */}
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            className="p-3 shadowDrawer"
          >
            <Typography variant="h3" gutterBottom className="drawer-title">
              Filters
            </Typography>
          </Stack>
          {/* Drawer head end */}
          {/* Drawer Content start */}
          <Stack
            className="p-3"
            style={{ height: "calc(100vh - 7rem)", overflowY: "scroll" }}
          >
            <form
              className="fs-13">
              <div className="mb-3 d-flex flex-column text-start">
                <label for="exampleInputfromdate" className="form-label">
                  From Date <small className="text-danger">*</small>
                </label>
                <input
                  type="date"
                  value={fromdate}
                  onChange={(e) => {
                    setFromdate(e.target.value);
                  }}
                  className="form-control form-control-lg"
                  id="exampleInputfromdate"
                />
                {fromDateError ? (
                  <span
                    className="text-danger mt-2"
                    style={{ fontSize: "10px" }}
                  >
                    From date should less than to date
                  </span>
                ) : (
                  ""
                )}
              </div>
              <div className="mb-3 d-flex flex-column text-start">
                <label for="exampleInputtodate" className="form-label">
                  To Date <small className="text-danger">*</small>
                </label>
                <input
                  value={todate}
                  type="date"
                  onChange={(e) => {
                    setTodate(e.target.value);
                  }}
                  className="form-control form-control-lg"
                  id="exampleInputtodate"
                />
              </div>
            </form>
          </Stack>
          {/* Drawer Content end */}
          {/* Drawer footer start */}
          <Stack
            className="p-2"
            sx={{
              position: "absolute",
              bottom: "0",
              background: "#f9f9f9",
              width: "100%",
              boxShadow:
                "rgba(14, 63, 126, 0.04) 0px 0px 0px 1px, rgba(42, 51, 69, 0.04) 0px 1px 1px -0.5px, rgba(42, 51, 70, 0.04) 0px 3px 3px -1.5px, rgba(42, 51, 70, 0.04) 0px 6px 6px -3px, rgba(14, 63, 126, 0.04) 0px 12px 12px -6px, rgba(14, 63, 126, 0.04) 0px 24px 24px -12px",
            }}
            direction="row"
            justifyContent="space-between"
            alignContent="center"
          >
            <Button
              variant="contained"
              className="me-2 w-100"
              sx={{
                textShadow: "0 1px 0 rgba(0, 0, 0, .4)",
                textTransform: "Capitalize",
              }}
              color="error"
              disableElevation
              onClick={() => {
                setShowFilter(false);
              }}
            >
              Close
            </Button>
            <Button
              variant="contained"
              className="me-2 w-100"
              sx={{
                textShadow: "0 1px 0 rgba(0, 0, 0, .4)",
                textTransform: "Capitalize",
              }}
              color="warning"
              disableElevation
              onClick={resetButton}
            >
              Reset
            </Button>
            <Button
              className="w-100"
              variant="contained"
              disableElevation
              sx={{
                textShadow: "0 1px 0 rgba(0, 0, 0, .4)",
                textTransform: "Capitalize",
              }}
              id="session_filter_Submit"
              onClick={() => {
                setPage(1);
                handleSubmit();
              }}
            >
              Submit
            </Button>
          </Stack>
          {/* Drawer footer end */}
        </Box>
      </Drawer>
      {/* Filters Drawer end  */}
    </StyledPaper >
    // Whatsapp Outbound Report  end here 
  );
};

export default connect(mapStateToProps, {
  setSelectedMenu,
})(WhatsappOutboundReport);
